import {
  MUTATION_PERFORM_SUBSCRIPION
} from "@/plugins/store"

export default {
  methods: {
    subscribePlanOLD(plan) {
      window.location = '/subscription/' + plan;
    },
    // plan = premium-1, premium-3, premium-12
    subscribePlan(plan) {
      this.$api.getSubscriptionUrl(plan).then((res) => {
        // console.log(res.data);
        this.$store.commit(MUTATION_PERFORM_SUBSCRIPION, res.data)
        /* DOES NOT WORK on iOS: (It is not within a click handler)
        let url = res.data.url;
        if (this.$common.isRunningInStandalone()) {
          this.$common.openPopupWindow(url)
        } else {
          this.$common.replaceLocation(url)
        }
        */
      }).catch(() => {});
    }
  }
}
